import { makeVar } from '@apollo/client'

export const tourRunStatusVar = makeVar(!localStorage.getItem('tourAlreadyRun'))
